import { Component, EventEmitter, OnDestroy, OnInit, Output, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, ElementRef, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import * as _ from 'lodash-es';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  buildHeaderDataShell,
  generalConfigFromGlobal,
  normalizeFilterParams,
  rowPayloadFromActiveScreen,
} from '../../../shared/workspace-element-context';
import { JsonObjectFactoryService } from '../../../shared/_services/json-object-factory.service';
import { BranchTaxCreditableAddService } from './branch-tax-creditable-add.service';

@Component({
    selector: 'gtw-branch-tax-creditable-add',
    templateUrl: './branch-tax-creditable-add.component.html',
    styleUrls: ['./branch-tax-creditable-add.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BranchTaxCreditableAddComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);


  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  private readonly subs = new Subscription();

  baseURLs: any = { 'admin': '', 'api': '', 'custom': '', 'efile': '', 'pdfEngine': '', 'bulkPdfEngine': '' };

  filterParams: any = {};

  globalService: any;
  appService: any = {
    USER_SETTINGS: '',
    SERVER_CONFIG: ''
  };
  GENERAL_CONFIG: any;

  rowData: any = {};

  // STANDARD COMPONENT PROPERTIES
  currentTabName = "Form Entry";
  minimise = false;
  isSaveClicked = false;
  crudLoading = false;
  showFormLoader = true;
  modalTitle = "Add Branch Tax";

  // Form data
  formData: any = {
    panel: true,
    enableCreditablePanel: true,
    enableNonCreditablePanel: false,
    spinner: true,
    isSection909SplitrTax: false,
    editFlagSet: false,
    creditableDropDown: [],
    generatedLeidDropDown: [],
    branchTaxTrailBalanceAmt: 0,
    variance: 0,
    openVariance: 0,
    totalBranchTaxes: 0,
    selectedBasketCatg: '',
    genLeid: '',
    selectedCountryDesc: '',
    selectedCountryKey: '',
    selectedBranchTaxLEID_Orgnl_CountryKey: '',
    creditTaxAmt: '',
    applicableYearKey: '',
    explainUsEntity: 'Not Applicable',
    creditableTagKey: null,
    selectStdReasonCd: '',
    detailReason: '',
    applicableYearKey2: '',
    nonCrdBrAmount: '',
    selectedSplitterBasketCatg: '',
    selectedSplitterCountryDesc: '',
    selectedSplitterCountryKey: '',
    nonCrdtableTagKey: null,
    selectedIssue: null,
    filterTaxYear: '',
    scenario: '',
    clientKey: 0,
    LEID: '',
    ReturnAsFiled: false,
    explainUsEntityRestore: ''
  };

  // Entity selection (for ADD mode)
  selectedCodeCombination: any = null;
  codeCombinationData: any[] = [];
  filteredCodeCombinationData: any[] = [];
  entitySearchTerm: string = '';
  showEntityDropdown: boolean = false;

  // Dropdown data
  issueDropdownData: any[] = [];
  basketCatgData: any[] = [];
  countryData: any[] = [];
  taxYearData: any[] = [];
  stdReasonCodeData: any[] = [];
  basketCodeDefault: any[] = [];
  countryUS: any[] = [];
  taxPriorYearStdReason: any[] = [];
  section909SplitrTax: any[] = [];
  filteredTaxYearData: any[] = [];
  filteredTaxYearForCreditable: any[] = [];
  attribMastData: any[] = [];
  defaultsMultipleSelected: any[] = [];
  isAmendedScenario: boolean = false;
  taxPriorYearCodeKey: string = '';
  section909SplitrTaxKey: string = '';
  logged_in_user: string = '';
  is_locked: any = null;

  // Data loading optimization
  private dataLoadingStates = {
    entityData: false,
    formData: false
  };

  constructor(
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
    private cdr: ChangeDetectorRef,
    private _snackBar: MatSnackBar, private gtwSnackbar: GtwSnackbarService,
    private jsonObjectFactory: JsonObjectFactoryService,
    private branchTaxService: BranchTaxCreditableAddService,
    private http: HttpClient,
    private elementRef: ElementRef
  ) { }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    // Close entity dropdown when clicking outside
    const customSelectContainer = this.elementRef.nativeElement.querySelector('.custom-select-container');
    if (customSelectContainer && !customSelectContainer.contains(event.target)) {
      this.showEntityDropdown = false;
      this.cdr.detectChanges();
    }
  }

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(this.gtwWorkspace.setTabActive.subscribe(() => {
      this.applyWorkspaceContext();
      this.init();
    }));
    this.subs.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => {
      this.applyWorkspaceContext();
      this.init();
    }));
    this.showFormLoader = true;
    this.init();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    this.dataLoadingStates = { entityData: false, formData: false };
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const header = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    this.baseURLs = generalConfigFromGlobal(this.gtwGlobal);
    this.GENERAL_CONFIG = header.generalConfigData || {};
    this.globalService = header;
    this.appService.USER_SETTINGS = header.userSettingsData || {};
    this.appService.SERVER_CONFIG = header.serverConfigData || {};
    this.filterParams = normalizeFilterParams(activeScreen);
    const row = rowPayloadFromActiveScreen(activeScreen);
    this.rowData = Array.isArray(row) ? (row[0] || {}) : row;
  }

  init() {
    try {
      if (this.GENERAL_CONFIG?.base_url) {
        this.loadInitialData();
      }
    } catch (e) {
      console.error('Error in branch-tax-creditable-add init:', e);
      this.showFormLoader = false;
    }
  }

  checkAllDataLoaded() {
    const allLoaded = Object.values(this.dataLoadingStates).every(state => state);
    if (allLoaded) {
      this.showFormLoader = false;
      this.cdr.detectChanges();
    }
  }

  loadInitialData() {
    if (!this.GENERAL_CONFIG || !this.GENERAL_CONFIG.base_url) {
      return;
    }

    // Get filter params
    this.formData.filterTaxYear = this.filterParams.tax_year || this.globalService?.globalParams?.tax_year;
    this.formData.scenario = this.filterParams.scenario || this.globalService?.globalParams?.scenario;
    this.formData.clientKey = this.globalService?.globalParams?.client_key || 0;
    this.isAmendedScenario = this.globalService?.globalParams?.issue_id != 0 && this.globalService?.globalParams?.issue_id != null;

    // Get logged in user
    this.logged_in_user = this.appService.USER_SETTINGS?.sso_id || this.appService.USER_SETTINGS?.user?.sso_id || '';

    // Load dropdowns
    this.getCodeCombinationData();
    this.getCreditableDropDown();
    this.getAttribMast();
    if (this.isAmendedScenario) {
      this.getIssueDropdown();
    }

    // Check lock status
    this.checkLockStatus();

    this.dataLoadingStates.entityData = true;
    this.dataLoadingStates.formData = true;
    this.checkAllDataLoaded();
  }

  checkLockStatus() {
    if (!this.GENERAL_CONFIG?.base_url || !this.filterParams?.scenario || !this.globalService?.globalParams?.jcd_key) return;

    const lockparams = {
      "action_code": 'n10cpv',
      "p_scenario": this.filterParams.scenario,
      "p_jcd_key": this.globalService.globalParams.jcd_key
    };

    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject',
      lockparams,
      this.globalService,
      null,
      null
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        if (response.callSuccess == '1' && response.jsonObject) {
          this.is_locked = response.jsonObject;
          this.formData.ReturnAsFiled = (this.is_locked != undefined && this.is_locked != null && this.is_locked[0]?.LOCK_STATUS == 'Y');
          this.cdr.detectChanges();
        }
      },
      (error: any) => {
        console.error('Error checking lock status:', error);
      }
    );
  }

  getCodeCombinationData() {
    if (!this.GENERAL_CONFIG?.base_url) {
      console.log('getCodeCombinationData: No base_url available');
      return;
    }

    console.log('getCodeCombinationData called with:', {
      base_url: this.GENERAL_CONFIG.base_url,
      filterTaxYear: this.formData.filterTaxYear,
      scenario: this.formData.scenario,
      globalService: this.globalService,
      filterParams: this.filterParams
    });

    // Build URL with query params directly using HttpClient
    const url = `${this.GENERAL_CONFIG.base_url}/loadJsonObject`;
    
    // Build complete params matching the expected payload
    const params: any = {
      action_code: 'g1mvvs',
      p_tax_year: this.formData.filterTaxYear || this.filterParams.tax_year || this.globalService?.globalParams?.tax_year,
      p_scenario: this.formData.scenario || this.filterParams.scenario || this.globalService?.globalParams?.scenario,
      tax_year: this.formData.filterTaxYear || this.filterParams.tax_year || this.globalService?.globalParams?.tax_year,
      scenario: this.formData.scenario || this.filterParams.scenario || this.globalService?.globalParams?.scenario,
      jcd_key: this.globalService?.globalParams?.jcd_key || this.filterParams.jcd_key || 250,
      activity_key: this.globalService?.globalParams?.activity_key || this.filterParams.activity_key || '',
      filing_key: this.globalService?.globalParams?.filing_key || this.filterParams.filing_key || 1,
      is_issue_key_enabled: this.globalService?.globalParams?.is_issue_key_enabled || 'N',
      is_locked: this.globalService?.globalParams?.is_locked || 'N',
      issue_id: this.globalService?.globalParams?.issue_id || '',
      issue_id_for_tx_save: this.globalService?.globalParams?.issue_id_for_tx_save || '',
      issue_short_desc: this.globalService?.globalParams?.issue_short_desc || '',
      jcd_ta_key: this.globalService?.globalParams?.jcd_ta_key || this.filterParams.jcd_ta_key || '',
      parent_me_string: this.globalService?.globalParams?.parent_me_string || this.filterParams.parent_me_string || '',
      scenarioCode: this.globalService?.globalParams?.scenarioCode || this.filterParams.scenarioCode || '',
      screen_key: this.globalService?.globalParams?.screen_key || this.filterParams.screen_key || '',
      screen_type: this.globalService?.globalParams?.screen_type || 'grid'
    };

    // Remove empty string params to keep request clean
    Object.keys(params).forEach(key => {
      if (params[key] === '' || params[key] === undefined || params[key] === null) {
        delete params[key];
      }
    });

    console.log('getCodeCombinationData API call:', url, params);

    this.http.get<any>(url, { params, withCredentials: true }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        console.log('getCodeCombinationData response:', response);
        if (response.callSuccess == '1' && response.jsonObject) {
          this.codeCombinationData = response.jsonObject;
          this.filteredCodeCombinationData = [...this.codeCombinationData];
          console.log('codeCombinationData loaded:', this.codeCombinationData.length, 'items');
          this.cdr.detectChanges();
        } else {
          console.log('getCodeCombinationData: No jsonObject in response or callSuccess != 1');
        }
      },
      (error: any) => {
        console.error('Error loading code combination data:', error);
      }
    );
  }

  onEntityInputFocus() {
    // Show dropdown and populate with all data
    this.filteredCodeCombinationData = [...this.codeCombinationData];
    this.showEntityDropdown = true;
    console.log('Entity input focused, showing dropdown with', this.filteredCodeCombinationData.length, 'items');
    this.cdr.detectChanges();
  }

  toggleEntityDropdown() {
    this.showEntityDropdown = !this.showEntityDropdown;
    if (this.showEntityDropdown) {
      this.filteredCodeCombinationData = [...this.codeCombinationData];
    }
    console.log('Toggle entity dropdown:', this.showEntityDropdown, 'items:', this.filteredCodeCombinationData.length);
    this.cdr.detectChanges();
  }

  filterEntities() {
    if (!this.entitySearchTerm || this.entitySearchTerm.trim() === '') {
      this.filteredCodeCombinationData = [...this.codeCombinationData];
    } else {
      const searchTerm = this.entitySearchTerm.toLowerCase();
      this.filteredCodeCombinationData = this.codeCombinationData.filter((cc: any) =>
        cc.VALUE && cc.VALUE.toLowerCase().includes(searchTerm)
      );
    }
    this.showEntityDropdown = true;
    this.cdr.detectChanges();
  }

  selectEntity(entity: any) {
    this.selectedCodeCombination = entity;
    this.entitySearchTerm = entity?.VALUE || '';
    this.showEntityDropdown = false;
    
    console.log('Entity selected:', entity);
    
    // Load generated LEID dropdown for selected entity
    if (entity) {
      this.getGeneratedLeidDropDown(entity);
    } else {
      // Clear the generated LEID dropdown if no entity selected
      this.formData.generatedLeidDropDown = [];
      this.formData.genLeid = '';
    }
    this.cdr.detectChanges();
  }

  getIssueDropdown() {
    if (!this.GENERAL_CONFIG?.base_url || !this.isAmendedScenario) return;

    const url = `${this.GENERAL_CONFIG.base_url}/getIssues?tax_year=${this.formData.filterTaxYear}&scenario=${this.formData.scenario}`;
    
    this.http.get<any>(url, { withCredentials: true }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.issueDropdownData = response.issue || [];
        this.cdr.detectChanges();
      },
      (error: any) => {
        console.error('Error loading issue dropdown:', error);
      }
    );
  }

  getCreditableDropDown() {
    if (!this.GENERAL_CONFIG?.base_url) return;

    const params = { "action_code": 'e83e1x' };

    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject',
      params,
      this.globalService,
      null,
      null
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        if (response.callSuccess == '1' && response.jsonObject) {
          this.basketCatgData = _.filter(response.jsonObject, (p: any) => _.includes(['SOURCE_CODE'], p.CODE_GROUP));
          this.basketCodeDefault = _.filter(this.basketCatgData, (p: any) => _.includes(['BRANCH'], p.CODE_SHORT_DESC));
          this.countryData = _.filter(response.jsonObject, (p: any) => _.includes(['COUNTRY_CODE'], p.CODE_GROUP));
          this.taxYearData = _.filter(response.jsonObject, (p: any) => _.includes(['TAX_YEAR'], p.CODE_GROUP));
          this.stdReasonCodeData = _.filter(response.jsonObject, (p: any) => _.includes(['STD_REASON_CODE'], p.CODE_GROUP));
          this.countryUS = _.filter(this.countryData, (p: any) => _.includes(['US'], p.CODE_SHORT_DESC));
          this.taxPriorYearStdReason = _.filter(this.stdReasonCodeData, (p: any) => _.includes(['TPPY'], p.CODE_SHORT_DESC));
          this.section909SplitrTax = _.filter(this.stdReasonCodeData, (p: any) => _.includes(['SUSPT'], p.CODE_SHORT_DESC));

          if (this.taxPriorYearStdReason.length > 0) {
            this.taxPriorYearCodeKey = '' + this.taxPriorYearStdReason[0].CODE_KEY;
          }
          if (this.section909SplitrTax.length > 0) {
            this.section909SplitrTaxKey = '' + this.section909SplitrTax[0].CODE_KEY;
          }

          // Set default basket
          if (this.basketCodeDefault.length > 0) {
            this.formData.selectedBasketCatg = '' + this.basketCodeDefault[0].CODE_KEY;
          }

          // Initialize tax year filters
          this.tillCurrentTaxYear(this.formData.filterTaxYear, 0, 11);
          this.isTaxPriorYear();

          this.cdr.detectChanges();
        }
      },
      (error: any) => {
        console.error('Error loading creditable dropdown data:', error);
      }
    );
  }

  getAttribMast() {
    if (!this.GENERAL_CONFIG?.base_url) return;

    const params = { "action_code": 'e0vg4g' };

    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject',
      params,
      this.globalService,
      null,
      null
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        if (response.callSuccess == '1' && response.jsonObject) {
          this.attribMastData = response.jsonObject;
          this.cdr.detectChanges();
        }
      },
      (error: any) => {
        console.error('Error loading attribute master data:', error);
      }
    );
  }

  getGeneratedLeidDropDown(selectedRowData: any) {
    if (!this.GENERAL_CONFIG?.base_url || !selectedRowData) return;

    const params = {
      "action_code": 'yxpce4',
      "p_tax_year": this.formData.filterTaxYear,
      "p_scenario": this.formData.scenario,
      "ho_leid": selectedRowData.HO_LEID,
      "ho_cdr_no": selectedRowData.HO_CDR_NO,
      "ho_reporting_pd": selectedRowData.HO_REPORTING_PERIOD,
    };

    console.log('getGeneratedLeidDropDown params:', params);

    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject',
      params,
      this.globalService,
      null,
      null
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        console.log('getGeneratedLeidDropDown response:', response);
        if (response.callSuccess == '1' && response.jsonObject) {
          this.formData.generatedLeidDropDown = response.jsonObject;
          this.cdr.detectChanges();
        }
      },
      (error: any) => {
        console.error('Error loading generated LEID dropdown:', error);
      }
    );
  }

  formatNumber(value: any): string {
    if (value == null || value == undefined) return '0';
    const num = parseInt(('' + value).replace(/\,/g, ''));
    return num.toLocaleString(undefined, { maximumFractionDigits: 0 });
  }

  tillCurrentTaxYear(currentYr: number, fromPriorYr: number, tillPriorYr: number) {
    this.filteredTaxYearData = [];
    this.filteredTaxYearForCreditable = [];

    for (const taxYear of this.taxYearData) {
      if (taxYear.CODE_GROUP === 'TAX_YEAR' &&
        taxYear.CODE_DISP_DESC <= (currentYr - fromPriorYr) &&
        taxYear.CODE_DISP_DESC >= (currentYr - tillPriorYr)) {
        this.filteredTaxYearData.push(taxYear);
        this.filteredTaxYearForCreditable.push(taxYear);
      }
    }

    // Defaulting the NonCreditable Applicable Year to Default Current Year
    this.formData.applicableYearKey2 = this.getTaxYearKey(currentYr - fromPriorYr);
    // Defaulting the Creditable Applicable Year to Default Current Year
    this.formData.applicableYearKey = this.getTaxYearKey(currentYr - fromPriorYr);

    this.cdr.detectChanges();
  }

  isTaxPriorYear() {
    if (this.formData.selectStdReasonCd && this.formData.selectStdReasonCd == this.taxPriorYearCodeKey) {
      this.tillCurrentTaxYear(this.formData.filterTaxYear, 1, 11);
    } else {
      this.tillCurrentTaxYear(this.formData.filterTaxYear, 0, 11);
    }

    this.formData.isSection909SplitrTax = (this.formData.selectStdReasonCd && this.formData.selectStdReasonCd == this.section909SplitrTaxKey);
    if (this.formData.isSection909SplitrTax) {
      this.formData.selectedSplitterBasketCatg = '' + this.basketCodeDefault[0]?.CODE_KEY;
    }
    this.cdr.detectChanges();
  }

  getCountryKey(countryDesc: string): string {
    const country = this.countryData.find((c: any) => c.CODE_DISP_DESC === countryDesc);
    return country ? '' + country.CODE_KEY : '';
  }

  getTaxYearKey(taxYearDesc: number): string {
    const taxYear = this.taxYearData.find((t: any) => t.CODE_DISP_DESC == taxYearDesc);
    return taxYear ? '' + taxYear.CODE_KEY : '';
  }

  changeLeCountry() {
    const selectedLeid = this.formData.generatedLeidDropDown.find((l: any) => l.LEID_LABEL === this.formData.genLeid);
    if (selectedLeid) {
      const country = this.countryData.find((c: any) => c.CODE_SHORT_DESC === selectedLeid.COUNTRY_CODE);
      if (country) {
        this.formData.selectedCountryDesc = country.CODE_DISP_DESC;
        this.formData.selectedCountryKey = '' + country.CODE_KEY;
        this.formData.selectedBranchTaxLEID_Orgnl_CountryKey = '' + country.CODE_KEY;
      }
    }
    this.updateExplainUsEntity();
    this.cdr.detectChanges();
  }

  updateExplainUsEntity() {
    if (this.formData.explainUsEntityRestore == '' && (this.formData.explainUsEntity != 'Not Applicable' && this.formData.explainUsEntity != '')) {
      this.formData.explainUsEntityRestore = this.formData.explainUsEntity;
    }
    if (this.formData.selectedBranchTaxLEID_Orgnl_CountryKey == this.countryUS[0]?.CODE_KEY) {
      if (this.formData.explainUsEntity == 'Not Applicable' && this.formData.explainUsEntityRestore == '') {
        this.formData.explainUsEntity = '';
      } else {
        this.formData.explainUsEntity = this.formData.explainUsEntityRestore;
      }
    } else {
      this.formData.explainUsEntity = 'Not Applicable';
    }
  }

  onRadioChange() {
    this.formData.enableCreditablePanel = this.formData.panel;
    this.formData.enableNonCreditablePanel = !this.formData.panel;
    this.cdr.detectChanges();
  }

  saveCreditAmtBranchTaxForm(): void {
    if (this.isSaveClicked) return;

    // Validate entity selection (ADD mode specific)
    if (!this.selectedCodeCombination) {
      this.gtwSnackbar.openSnackBar("Please select an Entity.", 'gtw-snackbar--red', true, 4);
      return;
    }

    // Validate issue selection for amended scenario
    if (this.isAmendedScenario && !this.formData.selectedIssue) {
      this.gtwSnackbar.openSnackBar("Please select an Issue.", 'gtw-snackbar--red', true, 4);
      return;
    }

    if (this.formData.ReturnAsFiled) {
      this.gtwSnackbar.openSnackBar(`Tax Return has already been filed for tax year ${this.formData.filterTaxYear}.`, 'gtw-snackbar--red', true, 4);
      return;
    }

    // Validation
    if (!this.formData.selectedBasketCatg || !this.formData.selectedCountryDesc || !this.formData.genLeid || !this.formData.applicableYearKey) {
      this.gtwSnackbar.openSnackBar("Please select/enter all the fields.", 'gtw-snackbar--red', true, 4);
      return;
    }

    if (this.formData.selectedBranchTaxLEID_Orgnl_CountryKey == this.countryUS[0]?.CODE_KEY && 
        (!this.formData.explainUsEntity || this.formData.explainUsEntity == '')) {
      this.gtwSnackbar.openSnackBar("Please enter explanation why Branch Tax LEID is US entity", 'gtw-snackbar--red', true, 4);
      return;
    }

    if (!this.formData.creditTaxAmt || this.formData.creditTaxAmt == '') {
      this.gtwSnackbar.openSnackBar("Please enter a valid Branch Tax Creditable Amount.", 'gtw-snackbar--red', true, 4);
      return;
    }

    if (this.formData.creditTaxAmt != undefined && this.formData.creditTaxAmt != null) {
      const validNumberWithDecimals = ((parseInt('' + this.formData.creditTaxAmt) - parseFloat('' + this.formData.creditTaxAmt)) !== 0);
      if (validNumberWithDecimals) {
        this.gtwSnackbar.openSnackBar("Please do not enter decimals for Branch Tax Creditable Amount.", 'gtw-snackbar--red', true, 4);
        return;
      }
    }

    this.isSaveClicked = true;
    this.crudLoading = true;
    this.cdr.detectChanges();

    const returnClobSettingsObj: any = {
      sso_id: this.logged_in_user,
      scenario: this.formData.scenario,
      object_id: this.selectedCodeCombination.KEY,
      tax_year: this.formData.filterTaxYear || this.filterParams.tax_year || this.globalService?.globalParams?.tax_year,
      jcd_key: this.globalService?.globalParams?.jcd_key || this.filterParams.jcd_key || 250,
      screen_key: this.globalService?.globalParams?.screen_key || this.filterParams.screen_key
    };

    const returnObj: any = {
      ISSUE_KEY: this.formData.selectedIssue,
      COMBINATION_KEY: this.selectedCodeCombination.KEY
    };

    returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'BASKET'])?.ATTRIB_KEY + '_0'] = this.formData.selectedBasketCatg;
    returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'GEN_LEID'])?.ATTRIB_KEY + '_0'] = this.formData.genLeid;
    returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'COUNTRY'])?.ATTRIB_KEY + '_0'] = this.getCountryKey(this.formData.selectedCountryDesc);
    const explanationValue = (this.formData.explainUsEntity === 'Not Applicable') ? '' : this.formData.explainUsEntity.replace(/'/g, "'");
    returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'EXPLANATION_CREDITABLE_US_ENTITY'])?.ATTRIB_KEY + '_0'] = explanationValue;
    returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'APPLICABLE_YEAR'])?.ATTRIB_KEY + '_0'] = this.formData.applicableYearKey;
    returnObj["IS_CREDITABLE"] = 'Y';
    returnObj["AMOUNT"] = this.formData.creditTaxAmt || 0;
    returnObj['GROUP_ID'] = 1;
    returnObj["TAG_KEY"] = null;
    returnObj["OPERATION_TYPE"] = 'I';

    const defaultsChangeDetails = [returnObj];

    this.branchTaxService.saveBranchTaxCreditableForm(
      this.GENERAL_CONFIG.base_url,
      returnClobSettingsObj,
      defaultsChangeDetails,
      this.globalService,
      this.filterParams,
      this.selectedCodeCombination
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.crudLoading = false;
        this.isSaveClicked = false;

        if (response.errorMessage && response.errorMessage !== 'null') {
          this.gtwSnackbar.openSnackBar(response.errorMessage, 'gtw-snackbar--red', true, 4);
        } else {
          this.gtwSnackbar.openSnackBar("Creditable Tax has been successfully saved", 'gtw-snackbar--green', true, 4);
          this.requestGridUpdate.emit('refresh');
        }
        this.cdr.detectChanges();
      },
      (error: any) => {
        this.crudLoading = false;
        this.isSaveClicked = false;
        console.error('Error saving creditable branch tax:', error);
        const errorMessage = error?.error?.errorMessage || error?.errorMessage ||
          (error?.error?.data?.errorMessage) ||
          "Error saving creditable branch tax. Please try again.";

        this.gtwSnackbar.openSnackBar(errorMessage, 'gtw-snackbar--red', true, 4);
        this.cdr.detectChanges();
      }
    );
  }

  saveNonCreditAmtBranchTaxForm(): void {
    if (this.isSaveClicked) return;

    // Validate entity selection (ADD mode specific)
    if (!this.selectedCodeCombination) {
      this.gtwSnackbar.openSnackBar("Please select an Entity.", 'gtw-snackbar--red', true, 4);
      return;
    }

    // Validate issue selection for amended scenario
    if (this.isAmendedScenario && !this.formData.selectedIssue) {
      this.gtwSnackbar.openSnackBar("Please select an Issue.", 'gtw-snackbar--red', true, 4);
      return;
    }

    if (this.formData.ReturnAsFiled) {
      this.gtwSnackbar.openSnackBar(`Tax Return has already been filed for tax year ${this.formData.filterTaxYear}.`, 'gtw-snackbar--red', true, 4);
      return;
    }

    // Validation
    if (!this.formData.selectStdReasonCd || !this.formData.detailReason || !this.formData.applicableYearKey2) {
      this.gtwSnackbar.openSnackBar("Please select/enter all the fields.", 'gtw-snackbar--red', true, 4);
      return;
    }

    if (!this.formData.nonCrdBrAmount || this.formData.nonCrdBrAmount == '') {
      this.gtwSnackbar.openSnackBar("Please enter a valid Branch Tax Non-Creditable Amount.", 'gtw-snackbar--red', true, 4);
      return;
    }

    if (this.formData.nonCrdBrAmount != undefined && this.formData.nonCrdBrAmount != null) {
      const validNumberWithDecimals = ((parseInt('' + this.formData.nonCrdBrAmount) - parseFloat('' + this.formData.nonCrdBrAmount)) !== 0);
      if (validNumberWithDecimals) {
        this.gtwSnackbar.openSnackBar("Please do not enter decimals for Branch Tax Non-Creditable Amount.", 'gtw-snackbar--red', true, 4);
        return;
      }
    }

    if (this.formData.selectStdReasonCd != undefined && this.formData.selectStdReasonCd == this.section909SplitrTaxKey) {
      if (!this.formData.selectedSplitterBasketCatg || !this.formData.selectedSplitterCountryDesc) {
        this.gtwSnackbar.openSnackBar("Please select Basket and Country for selected Standard Reason Amount is Non-Creditable.", 'gtw-snackbar--red', true, 4);
        return;
      }
    }

    this.isSaveClicked = true;
    this.crudLoading = true;
    this.cdr.detectChanges();

    const returnClobSettingsObj: any = {
      sso_id: this.logged_in_user,
      scenario: this.formData.scenario,
      object_id: this.selectedCodeCombination.KEY,
      tax_year: this.formData.filterTaxYear || this.filterParams.tax_year || this.globalService?.globalParams?.tax_year,
      jcd_key: this.globalService?.globalParams?.jcd_key || this.filterParams.jcd_key || 250,
      screen_key: this.globalService?.globalParams?.screen_key || this.filterParams.screen_key
    };

    const returnObj: any = {
      ISSUE_KEY: this.formData.selectedIssue,
      COMBINATION_KEY: this.selectedCodeCombination.KEY
    };

    returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'STANDARD_REASON_NOT_CREDITABLE'])?.ATTRIB_KEY + '_0'] = this.formData.selectStdReasonCd;
    returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'APPLICABLE_YEAR'])?.ATTRIB_KEY + '_0'] = this.formData.applicableYearKey2;
    returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'DETAIL_REASON_NOT_CREDITABLE'])?.ATTRIB_KEY + '_0'] =
      this.formData.detailReason.replace(/'/g, "'");

    if (this.formData.isSection909SplitrTax) {
      returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'BASKET'])?.ATTRIB_KEY + '_0'] = this.formData.selectedSplitterBasketCatg;
      returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'COUNTRY'])?.ATTRIB_KEY + '_0'] = this.getCountryKey(this.formData.selectedSplitterCountryDesc);
    } else {
      returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'BASKET'])?.ATTRIB_KEY + '_0'] = 0;
      returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'COUNTRY'])?.ATTRIB_KEY + '_0'] = 0;
    }

    returnObj["IS_CREDITABLE"] = 'N';
    returnObj["AMOUNT"] = this.formData.nonCrdBrAmount || 0;
    returnObj['GROUP_ID'] = 1;
    returnObj["TAG_KEY"] = null;
    returnObj["OPERATION_TYPE"] = 'I';

    const defaultsChangeDetails = [returnObj];

    this.branchTaxService.saveBranchTaxCreditableForm(
      this.GENERAL_CONFIG.base_url,
      returnClobSettingsObj,
      defaultsChangeDetails,
      this.globalService,
      this.filterParams,
      this.selectedCodeCombination
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.crudLoading = false;
        this.isSaveClicked = false;

        if (response.errorMessage && response.errorMessage !== 'null') {
          this.gtwSnackbar.openSnackBar(response.errorMessage, 'gtw-snackbar--red', true, 4);
        } else {
          this.gtwSnackbar.openSnackBar("Non-Creditable Tax has been successfully saved", 'gtw-snackbar--green', true, 4);
          this.requestGridUpdate.emit('refresh');
        }
        this.cdr.detectChanges();
      },
      (error: any) => {
        this.crudLoading = false;
        this.isSaveClicked = false;
        console.error('Error saving non-creditable branch tax:', error);
        const errorMessage = error?.error?.errorMessage || error?.errorMessage ||
          (error?.error?.data?.errorMessage) ||
          "Error saving non-creditable branch tax. Please try again.";

        this.gtwSnackbar.openSnackBar(errorMessage, 'gtw-snackbar--red', true, 4);
        this.cdr.detectChanges();
      }
    );
  }

  resetCreditable(): void {
    this.selectedCodeCombination = null;
    this.entitySearchTerm = '';
    this.formData.selectedBasketCatg = '' + this.basketCodeDefault[0]?.CODE_KEY;
    this.formData.creditTaxAmt = '';
    this.formData.genLeid = '';
    this.formData.selectedCountryDesc = '';
    this.formData.selectedCountryKey = '';
    this.formData.selectedBranchTaxLEID_Orgnl_CountryKey = '';
    this.formData.applicableYearKey = this.getTaxYearKey(this.formData.filterTaxYear);
    this.formData.explainUsEntity = 'Not Applicable';
    this.formData.creditableTagKey = null;
    this.formData.generatedLeidDropDown = [];
    this.cdr.detectChanges();
  }

  resetNonCreditable(): void {
    this.selectedCodeCombination = null;
    this.entitySearchTerm = '';
    this.tillCurrentTaxYear(this.formData.filterTaxYear, 0, 11);
    this.formData.selectStdReasonCd = '';
    this.formData.detailReason = '';
    this.formData.applicableYearKey2 = this.getTaxYearKey(this.formData.filterTaxYear);
    this.formData.nonCrdBrAmount = '';
    this.formData.selectedSplitterBasketCatg = '' + this.basketCodeDefault[0]?.CODE_KEY;
    this.formData.selectedSplitterCountryDesc = '';
    this.formData.nonCrdtableTagKey = null;
    this.formData.generatedLeidDropDown = [];
    this.cdr.detectChanges();
  }

  cancel(): void {
    this.requestGridUpdate.emit('cancel');
  }
}
